import axiosInstance from "../Api/AxiosInstance";
import { redirectHomeOnForbidden } from "./AdminAccessDeniedHelper";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const searchRevenueTransferEngagements = async (shareholderId: string, fiscalYearId = "", search = "", sortBy = "revenue", page = 0, pageSize = 25) =>
  (await axiosInstance.get(`${API_BASE_URL}/SearchRevenueTransferEngagements?shareholderId=${encodeURIComponent(shareholderId)}${fiscalYearId ? `&fiscalYearId=${encodeURIComponent(fiscalYearId)}` : ""}&search=${encodeURIComponent(search)}&sortBy=${encodeURIComponent(sortBy)}&page=${page}&pageSize=${pageSize}`)).data;

export const getRevenueTransferSummary = async (shareholderId: string, fiscalYearId: string) =>
  (await axiosInstance.get(`${API_BASE_URL}/GetRevenueTransferSummary?shareholderId=${encodeURIComponent(shareholderId)}&fiscalYearId=${encodeURIComponent(fiscalYearId)}`)).data;

export const getRevenueTransferYearSummaries = async (shareholderId: string) =>
  (await axiosInstance.get(`${API_BASE_URL}/GetRevenueTransferYearSummaries?shareholderId=${encodeURIComponent(shareholderId)}`)).data;

export const getRevenueTransferFiscalYearList = async () =>
  (await axiosInstance.get(`${API_BASE_URL}/RevenueTransferFiscalYearList`)).data;

export const getRevenueTransferShareholderList = async () =>
  (await axiosInstance.get(`${API_BASE_URL}/RevenueTransferShareholderList`)).data;

export const createRevenueTransfer = async (payload: any) =>
  (await axiosInstance.post(`${API_BASE_URL}/CreateRevenueTransfer`, payload)).data;

export const updateRevenueTransfer = async (payload: any) =>
  (await axiosInstance.put(`${API_BASE_URL}/UpdateRevenueTransfer`, payload)).data;


export const getSHFocusAreaDetails = async (
  token: any,
  shareholderId: string,
  fiscalYearId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/SHFocusAreaDetails?ShareholderId=${shareholderId}&FiscalYearId=${fiscalYearId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Shareholder focus area details:", error);
    throw error;
  }
};

export const getShareholderDetails = async (
  token: any,
  shareholderId: string,
  fiscalYearId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/ShareholderDetails?shareholderId=${shareholderId}&fiscalYearId=${fiscalYearId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Shareholder details:", error);
    throw error;
  }
};

export const getFiscalYearDetailsById = async (
  fiscalYearId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/FiscalYear?fiscalYearId=${fiscalYearId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Fiscal Year details:", error);
    throw error;
  }
};

export const getEvaluationDetails = async (
  shareholderId: string,
  fiscalYearId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/EvaluationPlan?shareholderId=${shareholderId}&fiscalYearId=${fiscalYearId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Evaluation details:", error);
    throw error;
  }
};

// export const UpdateFocusAreaPriority = async (token: any, ShareholderId: any, FiscalyearId: any, primary: any, secondary: any, tertiary: any) => {
//     try {

//         const response = await axios.get(`${API_BASE_URL}/UpdateFocusAreaPriority?ShareholderId=${ShareholderId}&FiscalYearId=${FiscalyearId}&
//             &Primary=${primary}&&Secondary=${secondary}&&Tertiary=${tertiary}`, {
//             headers: {
//                 'Authorization': `Bearer ${token}`
//             }
//         });
//         return response.data;
//     }
//     catch (error) {
//         console.error('Error updating priority of focus area :', error);
//         throw error;
//     }
// };

export const UpdateFocusAreaPriority = async (
  accessToken: string,
  shareholderIdURL: string,
  actionedBy: string,
  fiscalYearId: string,
  primaryFocusAreaId: string,
  secondaryFocusAreaId: string,
  tertiaryFocusAreaId: string
) => {
  const url = `${API_BASE_URL}/UpdateFocusAreaPriority`;

  try {
    const response = await axiosInstance.post(url, {
      shareholderIdURL,
      actionedBy,
      fiscalYearId,
      primaryFocusAreaId,
      secondaryFocusAreaId,
      tertiaryFocusAreaId,
    });

    return response.data;
  } catch (error: any) {
    console.error(
      "Error calling UpdateFocusAreaPriority Azure Function",
      error
    );
    throw error; // Let caller catch this
  }
};

export const getFieldMetaData = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}/ControlMetaData`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Field metadata:", error);
    throw error;
  }
};

export const SaveEvaluationDetailsAPI = async (
  type: string,
  shareholderId: string,
  fiscalYearId: string,
  focusAreaId: string,
  actionPlanId: string,
  sectionId: any | null,
  metricId: any,
  value: any,
  actionedBy: string
) => {
  const url = `${API_BASE_URL}/SaveEvaluationPlan`;

  try {
    const response = await axiosInstance.post(url, {
      type,
      shareholderId,
      fiscalYearId,
      focusAreaId,
      actionPlanId,
      sectionId,
      metricId,
      value,
      actionedBy,
    });

    return response;
  } catch (error: any) {
    console.error("Error calling SaveEvaluationPlan Azure Function", error);
    throw error; // Let caller catch this
  }
};

export const CheckEvaluationPlanAccess = async (
  viewerSHId: string,
  targetSHId: string,
  fiscalYearId: string,
  role?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/CheckEvaluationPlanAccess?viewerSHId=${viewerSHId}&targetSHId=${targetSHId}&fiscalYearId=${fiscalYearId}&role=${role}`
    );
    return response.data;
  } catch (error) {
    console.error("Error while checking evaluation plan access:", error);
    throw error;
  }
};

export const ValidateGUIDs = async (
  shareholderId: string,
  fiscalYearId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/ValidateGUIDs?sHId=${shareholderId}&fiscalYearId=${fiscalYearId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error while validating GUIDs:", error);
    throw error;
  }
};

export const FetchMetricDrillDownDetails = async (
  startDate: string,
  endDate: string,
  shareholderId: string,
  metricId: string,
  metricCode: string,
  groupBy?: string
) => {
  try {
    let url = `${API_BASE_URL}/FetchMetricDrillDownDetails?startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(
      endDate
    )}&shareholderId=${encodeURIComponent(
      shareholderId
    )}&metricId=${encodeURIComponent(metricId)}&metricCode=${encodeURIComponent(
      metricCode
    )}`;
    if (groupBy) {
      url += `&groupBy=${encodeURIComponent(groupBy)}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching metric drill down details:", error);
    throw error;
  }
};


export const FetchGroupingDetails = async (
  metricId: string
) => {
  try {
    const url = `${API_BASE_URL}/FetchMetricGroupingDetails?metricId=${metricId}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching metric grouping details:", error);
    throw error;
  }
}

// Fetch available plans / year list
export const GetAvailablePlans = async (shareholderId?: string) => {
  try {
    const url = shareholderId
      ? `${API_BASE_URL}/ListofPlans?shareholderId=${shareholderId}`
      : `${API_BASE_URL}/ListofPlans`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching available plans:", error);
    throw error;
  }
};

// Plan closure related APIs
export const GetPlanClosureStatus = async (shareholderId: string, fiscalYearId: string) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/PlanClosureDetails?shareholderId=${shareholderId}&fiscalYearId=${fiscalYearId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching plan closure status:", error);
    throw error;
  }
};

export const SubmitPlanClosure = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}/SavePlanClosureDetails`, payload);
    return response.data;
  } catch (error) {
    console.error("Error submitting plan closure:", error);
    throw error;
  }
};

// Lookup lists for Additional Plan Settings
export const getShareholderChannels = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}/ShareholderChannels`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shareholder channels:", error);
    throw error;
  }
};

export const getNonBillableFocusAreas = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}/NonBillableFocusAreas`);
    return response.data;
  } catch (error) {
    console.error("Error fetching non-billable focus areas:", error);
    throw error;
  }
};

// Additional Plan Settings APIs
export const getAdditionalPlanSettings = async (
  shareholderId: string,
  fiscalYearId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/AdditionalPlanSettings?ShareholderId=${shareholderId}&FiscalYearId=${fiscalYearId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching additional plan settings:", error);
    throw error;
  }
};

export const updateAdditionalPlanSettings = async (payload: {
  shareholderId: string;
  fiscalYearId: string;
  actionedBy: string;
  nonBillableFocusAreaIds: number[];
  shareholderChannelId: number | null;
}) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/UpdateAdditionalPlanSettings`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating additional plan settings:", error);
    throw error;
  }
};

export const getActiveShareholderList = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}/ActiveShareholderList`
    );
    return response.data;
  } catch (error) {
    redirectHomeOnForbidden(error);
    console.error("Error fetching active shareholder list:", error);
    throw error;
  }
};
